<script>
  import { get } from "svelte/store";
  import Select from "svelte-select";
  import { valuesForm } from "svelte-formly";
  import Field from "./Field.svelte";
  import dFields from "./fields.json";
  import dArea from "./area.json";
  import { readable } from "svelte/store";
  //import { trovaCoords, Latitudine, Longitudine, LatLong,  url } from "trovaURL";

  import en from "./i18n/en.json";
  import de from "./i18n/de.json";
  import it from "./i18n/it.json";
  import fr from "./i18n/fr.json";
  import es from "./i18n/es.json";

  import {
    R1,
    R2,
    R3,
    R4,
    R5,
    R6,
    R7,
    R8,
    R9,
    R10,
    R11,
    R12,
    R13,
    DENotes,
    RArea,
  } from "./drop_answer_de";
  import {
    F1,
    F2,
    F3,
    F4,
    F5,
    F6,
    F7,
    F8,
    F9,
    F10,
    F11,
    F12,
    F13,
    FRNotes,
    FArea,
  } from "./drop_answer_fr";
  import {
    E1,
    E2,
    E3,
    E4,
    E5,
    E6,
    E7,
    E8,
    E9,
    E10,
    E11,
    E12,
    E13,
    ESNotes,
    EArea,
  } from "./drop_answer_es";
  import {
    I1,
    I2,
    I3,
    I4,
    I5,
    I6,
    I7,
    I8,
    I9,
    I10,
    I11,
    I12,
    I13,
    INotes,
    IArea,
  } from "./drop_answer_it";
  import {
    EN1,
    EN2,
    EN3,
    EN4,
    EN5,
    EN6,
    EN7,
    EN8,
    EN9,
    EN10,
    EN11,
    EN12,
    EN13,
    ENNotes,
    ENArea,
  } from "./drop_answer_en";

  const valoriNota = [
    "geographic_coordinates",
    "engineers",
    "current_situation",
    "nr_interventions",
    "nr_last_year_interventions",
    "workshop_hourly_fee",
    "onsite_hourly_fee",
    "visited_audited",
    "alternator_competition",
    "gunset_competition",
    "reporting_degree_evaluation",
  ];

  const colonneGrandi = [
    "name1",
    "name2",
    "role1",
    "role2",
    "phone1",
    "phone2",
    "email1",
    "email2",
    "foundation_year",
    "certifications",
    "spoken_languages",
    "warranty",
    "total_staff",
    "engineers",
    "clerks",
    "workers",
    "crane",
    "max_capacity_crane",
    "fork_lift_truck",
    "max_capacity_forklift",
    "low_voltage_stator",
    "max_power_kva1",
    "max_power_kva2",
    "mv_hv_voltage_stator",
    "rotor",
    "max_poles",
    "balancing_machine",
    "max_diameter",
    "max_capacity",
    "max_lenght",
    "truck",
    "truck_capacity",
    "van",
    "van_capacity",
    "distance_range",
    "note3",
    "trouble_shooting",
    "power_up_to",
    "inspection",
    "commissioning",
    "bearing_replacement",
    "on_site_balancing",
    "alignment",
    "other5",
    "attachments",
    "note4",
    "references",
    "note5",
  ];
  var disabled = "true";
  let placeholder;
  let taglio;
  let esito = "";
  let ricarica;
  let selectArea = [];
  let APIrequest = "https://maps.googleapis.com/maps/api/geocode/json?address=";
  let presentazione;
  let aiuto;
  let messaggioCheck;
  let areas = dArea.data;
  let messaggioErrore = "";
  let invioRiuscito = "";
  let invioFallito = "";
  //il substring, fa si che ci siano solo 2 carattire nella lingua, per l'italiano era it-IT e quindi non lo prendeva e lo metteva in inglese

  let currentLanguage = navigator.language.substring(0, 2);

  var myCookie = sessionStorage.getItem("key");

  if (myCookie == "" || myCookie == null || !myCookie)
    myCookie = currentLanguage;

  function TrovaLingua() {
    myCookie = sessionStorage.setItem(
      "key",
      document.getElementById("lingua").value
    );
    location.reload();
  }

  function aggiornaPagina() {
    location.reload();
  }
  //Esperienza R1
  const R_esperienza = [
    "industrial_gen_sets",
    "marine",
    "cogeneration",
    "wind_turbines",
    "mv_hv",
    "hydro",
    "pmg",
    "welders",
    "portable",
    "rotating_ups",
    "electric_motors",
    "transformers",
    "400hz_aviation",
    "pumps",
    "endothermic_engines",
    "analogic_avr",
    "parallel_with_main",
    "digital_avr",
    "generators_parallel",
  ];
  //gunset controller R2
  const gunset_controller = "gunset_controller";
  //advance_digital_avr R3
  const advanced_digital_avr = "advanced_digital_avr";
  //Yes no outsource R4
  const YN_outoutsource = [
    "lathe",
    "milling_machine",
    "grinder",
    "hydraulic_press",
    "pyrolitic_oven",
    "torque_control_wrench",
    "bearing_induction_heater",
    "crane",
    "fork_lift_truck",
    "oscilloscope",
    "milliohm_meter",
    "megger",
    "vibrometer",
    "power_analyser",
    "surge_test",
    "multimeter",
    "infrared_therm",
    "bearing_diagnostics",
    "measuring_arm_cmm",
    "test_rig",
    "calipers",
    "micrometers",
    "dial_gauges",
    "bore_gauges",
    "low_voltage_stator",
    "mv_hv_voltage_stator",
    "rotor",
    "balancing_machine",
    "winding_vaccum_impregnation",
    "winding_bath_impregnation",
    "winding_drip_impregnation",
    "chrome_plating",
    "metal_spray_castolin",
    "drying_oven",
    "truck",
    "van",
    "epoxy_varnish_coating",
    "tropicalizing_varnish_coating",
  ];
  //power_up_to R5
  const power_up = "power_up_to";
  //distance range R6
  const distance_range = "distance_range";
  //current situation R7
  const current_situation = "current_situation";
  //yes no R8
  const yesNo = [
    "trouble_shooting",
    "inspection",
    "commissioning",
    "bearing_replacement",
    "on_site_balancing",
    "attachments",
    "photographic_report",
  ];
  //alignment R9
  const alignment = "alignment";
  //yes, service confirmed, not avaiable R10
  const service_status = [
    "mechanical_repairing_filter",
    "troubleshooting_on_site_filter",
    "portable_machines_filter",
    "industrial_machines_filter",
    "marine_machines",
    "400hz_machines_filter",
    "welders_filter",
    "mh_voltage_machines",
    "rewinding_filter",
  ];
  // approved/not approved, R11
  const evaluation = [
    "technical_degree_evaluation",
    "reporting_degree_evaluation",
  ];
  const ap = "meccalte_authorization";

  const translations = { en, de, es, it, fr };

  let avaiableLanguages = Object.keys(translations);

  if (avaiableLanguages.indexOf(myCookie) == -1) {
    currentLanguage = "en";
  }

  function getType(directusType) {
    switch (directusType) {
      case "integer":
      case "float":
        return "number";
      case "varchar":
      default:
        return "text";
      case "ALIAS":
        return "title";
    }
  }

  function getField(directusField) {
    switch (directusField) {
      case "m2o":
        return "select";
    }
  }

  function getInterface(directusInterface) {
    switch (directusInterface) {
      case "dropdown":
        return "select";
      case "many-to-one":
        return "select";
      case "area-dropdown":
        return "select";
      case "map":
        return "geo";
      case "custom-map":
        return "geo";
      case "divider":
        return "title";
    }
  }

  // serve per mettere in ordine tutti i form
  dFields.data = dFields.data.sort((a, b) => (a.sort > b.sort ? 1 : -1));

  //nasconde campi come ID e quelli che non bisogna far vedere
  dFields.data = dFields.data.filter(function (dField) {
    return !dField.readonly && !dField.hidden_browse && !dField.readonly;
  });

  //nasconde i campi riservati in base al sort dal 147 al 174 sono i valori .sort da nascondere
  dFields.data = dFields.data.filter(function (dField) {
    return dField.sort < 150;
  });

  let val = [];

  for (let i = 0; i < Object.values(dArea)[0].length; i++) {
    selectArea.push(Object.values(dArea)[0][i].area_name);
  }

  var url_string = window.location.href;
  var url = new URL(url_string);
  var param_area = url.searchParams.get("area");

  if (param_area) {
    if (param_area > 15) {
      param_area = 15;
    }
    if (param_area < 2) {
      param_area = 2;
    }
  }

  let notes = [];

  const fields = dFields.data.map(function (dField) {
    // Trasformo la notazione di directus in un oggetto "digeribile" da formly
    if (!translations[myCookie]) {
      myCookie = "en";
    }

    let field = {
      name: dField.field,
      id: dField.field,
      prefix: {
        class: ["col-sm-4", "mb-5", "title"],
      },
      note: dField.note,
      class: ["form-control"],
      label: translations[myCookie][dField.field],
      validation: [dField.length],
    };
    let check = dField.field;

    notes.push(field.name, field.validation);

    // field.max = dField.length;
    // field.validation.push(field.max);

    if (dField.interface != "dropdown") {
      if (dField.interface == "text-input" && dField.field == "email") {
        field.type = "email";
        field.validation.push("email");
      } else if (
        dField.interface == "text-input" &&
        dField.field == "email_2"
      ) {
        field.type = "email";
        field.validation.push("email");
      } else if (
        dField.interface == "map" ||
        dField.interface == "custom-map"
      ) {
        field.type = "geo";
      } else if (dField.field == "telephone") {
        field.type = "tel";
      } else if (dField.interface == "date") {
        field.type = "date";
      } else {
        if (dField.field == "area" || dField.field == "area-dropdown") {
          field.type = getInterface(dField.interface);
          let nuovo = [];

          switch (myCookie) {
            case "de":
              placeholder = "Wähle eine Option";
              presentazione = "SPQ - FRAGEBOGEN NACH VERKAUFSDIENSTPUNKT";
              ricarica = "Aktualisierung";
              aiuto = "Erforderliche Felder sind mit * gekennzeichnet";
              messaggioCheck = "Aktivieren Sie das Senden von Daten";
              break;
            case "fr":
              placeholder = "Sélectionnez une option";
              presentazione =
                "SPQ - QUESTIONNAIRE DU POINT DE SERVICE APRÈS-VENTE";
              ricarica = "Rafraîchir";
              aiuto = "Les champs obligatoires sont marqués avec *";
              messaggioCheck = "Activer l'envoi de données";
              break;
            case "es":
              placeholder = "Seleccione una opción";
              presentazione =
                "SPQ - CUESTIONARIO DE PUNTOS DE SERVICIO DESPUÉS DE VENTAS";
              ricarica = "Actualizar";
              aiuto = "Los campos obligatorios están marcados con *";
              messaggioCheck = "Habilitar el envío de datos";
              break;
            case "it":
              placeholder = "Seleziona un'Opzione";
              presentazione =
                "SPQ - QUESTIONARIO SUI CENTRI ASSISTENZA POST-VENDITA";
              ricarica = "Ricarica";
              aiuto = "I campi obbligatori sono contrassegnati con *";
              messaggioCheck = "Abilita invio dati";
              break;
            case "en":
              placeholder = "Select an Option";
              presentazione = "SPQ - AFTER SALES SERVICE POINT QUESTIONNAIRE";
              ricarica = "Refresh";
              aiuto = "Required fields are marked with *";
              messaggioCheck = "Enable data sending";
              break;
            default:
              placeholder = "Select an Option";
              presentazione = "SPQ - AFTER SALES SERVICE POINT QUESTIONNAIRE";
              ricarica = "Refresh";
              aiuto = "Required fields are marked with *";
              messaggioCheck = "Enable data sending";
          }

          let valoriLingua = [];
          valoriLingua = trovaArea();
          if (param_area == null || param_area == "") {
            let y = {
              disabled: "disabled",
              selected: "selected",
              value: "dummy_value",
              title: placeholder,
            };
            nuovo.push(y);
            for (var i = 0; i < areas.length; i++) {
              let valoriLingua = [];
              valoriLingua = trovaArea();
              let x = {
                title: valoriLingua[i],
                value: areas[i].id,
              };
              nuovo.push(x);
            }
          } else {
            var giusto = parseInt(param_area);
            let ciclo;
            for (ciclo = 0; ciclo < areas.length; ciclo++) {
              if (areas[ciclo].id == param_area) {
                break;
              }
            }
            let y = {
              selected: "selected",
              value: param_area,
              title: valoriLingua[ciclo],
            };
            nuovo.push(y);
          }
          field.options = nuovo;
        } else {
          field.type = getType(dField.type);
        }
      }
    } else if (field.name == "service_type") {
      field.type = getInterface(dField.interface);

      let doc = dField.options.choices;

      doc = Object.values(doc);

      const nuovo = [];

      let valore = "SERVICE";

      for (var i = 0; i < 1; i++) {
        let x = {
          title: valore,
          value: doc[i],
        };

        nuovo.push(x);
      }
      field.options = nuovo;
    } else {
      field.type = getInterface(dField.interface);

      let doc = dField.options.choices;

      doc = Object.values(doc);

      const nuovo = [];

      let x;

      switch (myCookie) {
        case "de":
          x = trovaCampo_de(field.name);
          break;
        case "fr":
          x = trovaCampo_fr(field.name);
          break;
        case "es":
          x = trovaCampo_es(field.name);
          break;
        case "it":
          x = trovaCampo_it(field.name);
          break;
        case "en":
          x = trovaCampo_en(field.name);
          break;
        default:
          x = trovaCampo_en(field.name);
      }
      let valoriTradotti = x;

      let y = {
        disabled: "disabled",
        selected: "selected",
        value: "dummy_value",
        title: placeholder,
      };
      nuovo.push(y);
      for (var i = 0; i < doc.length; i++) {
        let x = {
          title: valoriTradotti[i],
          value: doc[i],
        };

        nuovo.push(x);
      }
      field.options = nuovo;
    }

    //se vede che un divider gli mette colonne:12 in modo da essere sempre al centro
    if (dField.type == "ALIAS") {
      field.prefix = {
        class: ["col-sm-12 titolone"],
      };
    }

    //se la note (che è il tooltip) è diversa da nulla, cioè esiste, e non è un divider, allora assegna la nota al campo e mette la nota in lingua
    if (dField.note != "" || dField.type != "ALIAS") {
      switch (myCookie) {
        case "de":
          field.note = DENotes[trovaNote(field.name)];
          break;
        case "fr":
          field.note = FRNotes[trovaNote(field.name)];
          break;
        case "es":
          field.note = ESNotes[trovaNote(field.name)];
          break;
        case "it":
          field.note = INotes[trovaNote(field.name)];
          break;
        case "en":
          field.note = ENNotes[trovaNote(field.name)];
          break;
        default:
          field.note = ENNotes[trovaNote(field.name)];
      }
    }

    if (field.name == "website") {
      field.prefix.class.push("website");
    }
    if (field.name == "date") {
      field.type = "date";
    }

    if (param_area) {
      if (field.name == "area" || field.name == "area-dropdown") {
        field.prefix.class.push("hidden");
      }
    }
    if (field.name == "date_authorization") {
      field.prefix.class.push("date_authorization");
    }

    if (field.name == "service_type") {
      field.prefix.class.push("hidden");
    }

    if (
      field.name == "company_name" ||
      field.name == "address" ||
      field.name == "post_code" ||
      field.name == "location_city" ||
      field.name == "province_region_state" ||
      field.name == "country" ||
      field.name == "telephone" ||
      field.name == "email" ||
      field.name == "area" ||
      field.name == "area-dropdown" ||
      field.name == "geographic_coordinates"
    ) {
      field.validation.push("required");
    }

    if (colonneGrandi.includes(field.name)) {
      field.prefix.class.push("col-sm-6");
    }
    if (field.name == "status") {
      field.prefix.class.push("hidden");
    }

    return field;
  });

  function trovaNote(stringa) {
    if (valoriNota.includes(stringa))
      var indexx = valoriNota.findIndex((pippo) => pippo == stringa);

    return indexx;
  }
  function trovaCampo_de(stringa) {
    if (R_esperienza.includes(stringa)) {
      return R1;
    } else if (stringa == "gunset_controller") {
      return R2;
    } else if (stringa == "advanced_digital_avr") {
      return R3;
    } else if (YN_outoutsource.includes(stringa)) {
      return R4;
    } else if (stringa == "power_up_to") {
      return R5;
    } else if (stringa == "distance_range") {
      return R6;
    } else if (stringa == "current_situation") {
      return R7;
    } else if (yesNo.includes(stringa)) {
      return R8;
    } else if (stringa == "alignment") {
      return R9;
    } else if (service_status.includes(stringa)) {
      return R10;
    } else if (stringa == "meccalte_authorization") {
      return R11;
    } else if (evaluation.includes(stringa)) {
      return R12;
    } else if (stringa == "service_type") {
      return R12;
    } else {
      return;
    }
  }
  function trovaCampo_fr(stringa) {
    if (R_esperienza.includes(stringa)) {
      return F1;
    } else if (stringa == "gunset_controller") {
      return F2;
    } else if (stringa == "advanced_digital_avr") {
      return F3;
    } else if (YN_outoutsource.includes(stringa)) {
      return F4;
    } else if (stringa == "power_up_to") {
      return F5;
    } else if (stringa == "distance_range") {
      return F6;
    } else if (stringa == "current_situation") {
      return F7;
    } else if (yesNo.includes(stringa)) {
      return F8;
    } else if (stringa == "alignment") {
      return F9;
    } else if (service_status.includes(stringa)) {
      return F10;
    } else if (stringa == "meccalte_authorization") {
      return F11;
    } else if (evaluation.includes(stringa)) {
      return F12;
    } else if (stringa == "service_type") {
      return F13;
    } else {
      return;
    }
  }
  function trovaCampo_es(stringa) {
    if (R_esperienza.includes(stringa)) {
      return E1;
    } else if (stringa == "gunset_controller") {
      return E2;
    } else if (stringa == "advanced_digital_avr") {
      return E3;
    } else if (YN_outoutsource.includes(stringa)) {
      return E4;
    } else if (stringa == "power_up_to") {
      return E5;
    } else if (stringa == "distance_range") {
      return E6;
    } else if (stringa == "current_situation") {
      return E7;
    } else if (yesNo.includes(stringa)) {
      return E8;
    } else if (stringa == "alignment") {
      return E9;
    } else if (service_status.includes(stringa)) {
      return E10;
    } else if (stringa == "meccalte_authorization") {
      return E11;
    } else if (evaluation.includes(stringa)) {
      return E12;
    } else if (stringa == "service_type") {
      return E13;
    } else {
      return;
    }
  }
  function trovaCampo_it(stringa) {
    if (R_esperienza.includes(stringa)) {
      return I1;
    } else if (stringa == "gunset_controller") {
      return I2;
    } else if (stringa == "advanced_digital_avr") {
      return I3;
    } else if (YN_outoutsource.includes(stringa)) {
      return I4;
    } else if (stringa == "power_up_to") {
      return I5;
    } else if (stringa == "distance_range") {
      return I6;
    } else if (stringa == "current_situation") {
      return I7;
    } else if (yesNo.includes(stringa)) {
      return I8;
    } else if (stringa == "alignment") {
      return I9;
    } else if (service_status.includes(stringa)) {
      return I10;
    } else if (stringa == "meccalte_authorization") {
      return I11;
    } else if (evaluation.includes(stringa)) {
      return I12;
    } else if (stringa == "service_type") {
      return I13;
    } else {
      return;
    }
  }
  function trovaCampo_en(stringa) {
    if (R_esperienza.includes(stringa)) {
      return EN1;
    } else if (stringa == "gunset_controller") {
      return EN2;
    } else if (stringa == "advanced_digital_avr") {
      return EN3;
    } else if (YN_outoutsource.includes(stringa)) {
      return EN4;
    } else if (stringa == "power_up_to") {
      return EN5;
    } else if (stringa == "distance_range") {
      return EN6;
    } else if (stringa == "current_situation") {
      return EN7;
    } else if (yesNo.includes(stringa)) {
      return EN8;
    } else if (stringa == "alignment") {
      return EN9;
    } else if (service_status.includes(stringa)) {
      return EN10;
    } else if (stringa == "meccalte_authorization") {
      return EN11;
    } else if (evaluation.includes(stringa)) {
      return EN12;
    } else if (stringa == "service_type") {
      return EN13;
    } else {
      return;
    }
  }
  function trovaArea() {
    switch (myCookie) {
      case "de":
        messaggioErrore =
          "Bitte geben Sie die Koordinaten im richtigen Format ein";
        invioFallito = "Einfügefehler, Senden fehlgeschlagen";
        invioRiuscito = "Formular korrekt gesendet";
        return RArea;
      case "fr":
        messaggioErrore = "Veuillez insérer les coordonnées dans le bon format";
        invioFallito = "Erreurs d'insertion, échec d'envoi";
        invioRiuscito = "Formulaire envoyé correctement";
        return FArea;
      case "es":
        messaggioErrore =
          "Por favor inserte las coordenadas en el formato correcto";
        invioFallito = "Errores de inserción, envío fallido";
        invioRiuscito = "Formulario enviado correctamente";
        return EArea;
      case "it":
        messaggioErrore =
          "Perfavore Inserisci le coordinate nel formato corretto";
        invioFallito = "Errori nell'inserimento, invio non riuscito";
        invioRiuscito = "Modulo inviato correttamente!";
        return IArea;
      case "en":
        messaggioErrore = "Please insert coordinates in the right format";
        invioFallito = "Errors in the form. Form has not been sent";
        invioRiuscito = "The form has been sent!";
        return ENArea;
        messaggioErrore = "Please insert coordinates in the right format";
        invioFallito = "Errors in the form. Form has not been sent";
        invioRiuscito = "The form has been sent!";
        return ENArea;
    }
  }

  const Tokens = [
    "AdtT5ddfJwfzKUBhaXCdCpqg", //Admin, non dovrebbe essere raggiungibile
    "Ka9V4TlMdpguABmJV5yu2BFW", //User API, non dovrebbe essere raggiungibile
    "5LaHBTfARWx8mkUMZZAIAFwz", // Italy
    "L85P6E81HSXDXlFZGmWioso3", // Spain
    "N6EW68qpVcWZizNBXYbIOjnz", // UK/EIRE
    "8NBVHeTXT7Spcuamj42TiABV", // Germany
    "gF1SuDy8bcAYHkGihqUjgUEb", // France
    "MiSqPPk1JUhjzyw2Lp4Gejjl", // Russia
    "fHVgNQb4gSGiIP7UyGpLTWwR", // EU Other Countries
    "d5wF7XwsvDbqKjO7V8dtyJs4", // Africa
    "bBRkcJNNULPAuZOSd9Rcmh7f", // Nord America
    "HaG6HumPd5Dxt8cV8ZlqPo3y", // Central Amirica
    "jIezxJP0LU4twSaVVgQe9kHM", // Sud Amirica
    "ERI14bKtBMHuuUoWS8L3lUyB", // Middle East
    "INd8aP0fkEeYEF0LHKeZcYlj", // Far East India
    "WHY5TDyaEQHfOlBHIVDPMA8p", // Far East
  ];

  function trovaToken() {
    let area_value = document.getElementById("area").value; //from 2 to 15
    return Tokens[area_value];
  }
  function trovaInvio() {
    let x;
    switch (myCookie) {
      case "de":
        x = "Senden";
        bandiera = "/german_icon.png";
        break;
      case "fr":
        x = "Envoyer";
        bandiera = "/french_icon.png";
        break;
      case "es":
        x = "Enviar";
        bandiera = "/spanish_icon.png";
        break;
      case "it":
        x = "Invia";
        bandiera = "/italian_icon.png";
        break;
      case "en":
        x = "Send";
        bandiera = "/english_icon.png";
        break;
      default:
        x = "Send";
        bandiera = "/english_icon.png";
    }
    return x;
  }
  let bandiera;

  function mostraEsito(Scritta, colore) {
    var x = (document.getElementById("esito").style.visibility = "visible");
    var y = (document.getElementById("esito_txt").style.visibility = "visible");
    var z = (document.getElementById("esito_txt").innerHTML = Scritta);
    var w = (document.getElementById("esito_txt").style.color = colore);
  }

  let src = "/logo_scritta.png";
  let invio = trovaInvio();

  let valoriNecessari = [
    "company_name",
    "address",
    "location_city",
    "telephone",
    "email",
    "geographic_coordinates",
    "country",
    "area",
  ];

  let i = 0;

  function abilitabottone() {
    let data = get(valuesForm).values;
    let name, name_lng;
    aggiungiMaxLenght();

    for (name in data) {
      let tmp = data[name];
      if (valoriNecessari.includes(name)) {
        if (
          data[name] != "" &&
          data[name] != null &&
          data[name] != "dummy_value"
        ) {
          i++;
          if (param_area) {
            if (i >= 7) {
              document
                .getElementById("bottoneFinale")
                .removeAttribute("disabled");
            }
          } else if (i >= 7)
            document
              .getElementById("bottoneFinale")
              .removeAttribute("disabled");
        }
      } else continue;
    }
  }

  function selectElement(id, valueToSelect) {
    let element = document.getElementById(id);
    element.value = valueToSelect;
  }
  document.addEventListener(
    "DOMContentLoaded",
    function () {
      if (param_area) selectElement("area", param_area);
    },
    false
  );

  window.addEventListener(
    "keydown",
    function (e) {
      if (
        e.keyIdentifier == "U+000A" ||
        e.keyIdentifier == "Enter" ||
        e.keyCode == 13
      ) {
        if (e.target.nodeName == "INPUT" && e.target.type == "text") {
          e.preventDefault();
          return false;
        }
      }
    },
    true
  );

  function aggiungiMaxLenght() {
    let data = get(valuesForm).values;
    let name, name_lng;
    for (name in data) {
      let tmp = data[name];
      for (let i = 0; i < notes.length; i++) {
        if (notes[i] == name) {
          document
            .getElementById(name)
            .setAttribute("maxLength", notes[i + 1][0]);
        }
      }
    }
  }

  function sendForm(event) {
    document
      .getElementById("bottoneFinale")
      .setAttribute("disabled", "disabled");
    const XHR = new XMLHttpRequest();
    esito = "/error.png";
    let data = get(valuesForm).values;
    let urlEncodedData = "",
      urlEncodedDataPairs = [],
      name,
      name_lng;

    let p = get(valuesForm);

    if (
      document.getElementById("geographic_coordinates").value == "" ||
      document.getElementById("geographic_coordinates").value == null
    ) {
      esito = "/error.png";
      alert(messaggioErrore);
      document.getElementById("esito").src = esito;
      document.getElementById("company_name").focus();
      return (x = mostraEsito(invioFallito, "red"));
    }

    if (
      (p.isValidForm &&
        document.getElementById("geographic_coordinates").value != "" &&
        document.getElementById("geographic_coordinates").value != null &&
        document.getElementById("geographic_coordinates").value &&
        document.getElementById("area").value != "dummy_value") ||
      document.getElementById("area").value != ""
    ) {
      for (name in data) {
        var value = data[name];

        if (document.getElementById(name).value == "dummy_value") value = "";

        if (name == "geographic_coordinates") {
          name = "geographic_coordinates[lat]";
          name_lng = "geographic_coordinates[lng]";

          value = document.getElementById("geographic_coordinates").value;
          let Coords;
          Coords = value.split(",");

          try {
            value = [];
            value["lat"] = Coords[0].trim();
            value["lng"] = Coords[1].trim();
          } catch (err) {
            esito = "/error.png";
            document.getElementById("esito").src = esito;
            var x = mostraEsito(invioFallito, "red");
            alert(messaggioErrore);
            document.getElementById("company_name").focus();
            return;
          }

          urlEncodedDataPairs.push(
            encodeURIComponent(name) + "=" + encodeURIComponent(value["lat"]),
            encodeURIComponent(name_lng) +
              "=" +
              encodeURIComponent(value["lng"])
          );
        } else if (value == "" || value == null) continue;
        else if (name == "geographic_coordinates") continue;
        else {
          urlEncodedDataPairs.push(
            encodeURIComponent(name) + "=" + encodeURIComponent(value)
          );
        }
      }

      urlEncodedData = urlEncodedDataPairs.join("&").replace(/%20/g, "+");

      XHR.addEventListener("error", function (event) {
        alert("Oops! Something went wrong.");
        return;
      });

      XHR.open(
        "POST",
        "https://network.meccalte.dev72.proteinic.com/mecc-alte-network/items/dealers"
      );

      let s1, s2, s3;
      s1 = "Bearer ";
      s2 = trovaToken();
      s3 = s1 + s2;
      XHR.setRequestHeader("Authorization", s3);
      //XHR.setRequestHeader("Authorization", "Bearer Ka9V4TlMdpguABmJV5yu2BFW");
      XHR.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

      XHR.send(urlEncodedData);

      XHR.addEventListener("load", function () {
        if (XHR.status == 200 || XHR.status == 202) {
          var x = (document.getElementById("fresco").style.visibility =
            "visible");
          var t = (document.getElementById("formDati").style.display = "none");
          esito = "/positive.png";
          document.getElementById("esito").src = esito;
          var x = mostraEsito(invioRiuscito, "green");
        } else if (XHR.status >= 500) {
          esito = "/error.png";
          document.getElementById("esito").src = esito;
          invioFallito = "Network Error, Try again Later";
          var x = mostraEsito(invioFallito, "red");
        } else {
          esito = "/error.png";
          document.getElementById("esito").src = esito;
          var x = mostraEsito(invioFallito, "red");
        }
      });
    } else {
      esito = "/error.png";
      document.getElementById("esito").src = esito;
      var x = mostraEsito(invioFallito, "red");
      alert(messaggioErrore);
      document.getElementById("company_name").focus();
    }
  }
</script>

<style>
  main {
    padding-bottom: 250px;
  }

  input[type="checkbox"] {
    transform: scale(1.5);
  }

  @media (max-width: 700px) {
    main {
      padding-bottom: 400px;
    }
  }

  * {
    font-size: 20px;
    font-weight: 400;
  }

  :global(.titolo) {
    padding-top: 20px;
    margin-bottom: 5px;
  }

  :global(.titolone > *) {
    text-align: center;
    padding-top: 20px;
    padding-bottom: 40px;
    width: 50%;
    float: none !important;
  }

  :global(.col-sm-12) {
    text-align: center;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 25px;
    text-align: center;
  }

  :global(.col-sm-4) {
    font-size: 15px;
    display: inline-block !important;
  }

  :global(#logo img) {
    max-width: 300px;
    width: 100%;
  }
  :global(.logo) {
    display: block;
    text-align: center;
  }

  :global(.trovaCoords) {
    margin-left: 10px;
    align-self: center;
  }

  :global(.geo) {
    display: flex;
  }

  :global(.invioForm) {
    display: block;
    margin-top: 100px;
  }

  :global(.col-sm-4.mb-5.title.date_authorization) {
    margin-bottom: 20px !important;
  }

  :global(.finale) {
    padding: 0;
    margin: 0;
    text-align: center;
  }
  :global(.linguaBandiera) {
    display: flex;
    justify-content: flex-end;
  }

  :global(.selectLingua) {
    margin-top: 10px;
  }

  :global(.esito) {
    text-align: center;
    visibility: hidden;
  }
  :global(small) {
    position: absolute;
  }
  :global(.esito_positivo) {
    color: green;
  }

  :global(.esito_negativo) {
    color: red;
  }

  :global(.hidden) {
    display: none !important;
  }
  :global(.aiuto) {
    text-align: center !important;
    font-weight: 400 !important;
    font-size: 18px !important;
    text-align: center !important;
    color: grey;
    text-transform: none !important;
  }
  :global(.titolo[for="contact_persons"]) {
    margin-top: 100px;
  }
</style>

<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <!-- <meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests"> -->
  <script
    src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
    integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
    crossorigin="anonymous">
  </script>
  <script
    src="https://cdn.jsdelivr.net/npm/popper.js@1.16.0/dist/umd/popper.min.js"
    integrity="sha384-Q6E9RHvbIyZFJoft+2mJbHaEWldlvI9IOYy5n3zV9zzTtmI3UksdQRVvoxMfooAo"
    crossorigin="anonymous">
  </script>
  <link
    rel="stylesheet"
    href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css"
    integrity="sha384-9aIt2nRpC12Uk9gS9baDl411NQApFmC26EwAOH8WgZl5MYYxFfc+NcPb1dKGj7Sk"
    crossorigin="anonymous" />
  <script
    src="https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/js/bootstrap.min.js"
    integrity="sha384-OgVRvuATP1z7JjHLkuOU7Xw704+h835Lr+6QL9UvYjZE3Ipu6Tp75j7Bh/kR0JKI"
    crossorigin="anonymous">
  </script>
  <script
    src="https://maps.googleapis.com/maps/api/js?key=AIzaSyB8WIcB8CmhFAo8F_IlsSbcR-UGhgzq7jM&libraries=geometry">
  </script>
</head>

<main class="container">
  <div class="clearfix linguaBandiera">
    <select
      name="lingua"
      id="lingua"
      class="selectLingua custom-select col-sm-2"
      on:change={TrovaLingua}>
      <option value="vuoto">Select Language</option>
      <option value="en" class="en">English</option>
      <option value="it" class="it">Italiano</option>
      <option value="es" class="es">Español</option>
      <option value="fr" class="fr">Français</option>
      <option value="de" class="de">Deutsche</option>
    </select>
    <img
      src={bandiera}
      alt=""
      class="bandiera"
      style="max-width:40px; margin-left:10px; margin-top:8px;" />
  </div>

  <div id="logo" class="logo mb-5"><img {src} alt="" /></div>

  <div class="row">
    <form
      action="https://network.meccalte.dev72.proteinic.com/mecc-alte-network/items/dealers"
      method="POST"
      id="formDati"
      on:change={abilitabottone}>
      <h1 class="col-sm-12">{presentazione}</h1>
      <p id="aiuto" class="aiuto col-sm-12">{aiuto}</p>
      <Field {fields} />
      <br />
      <div class="finale">
        <div class="pt-5">
          <!-- <input id="cancello" type="checkbox" />
          <label>{messaggioCheck}</label> -->
        </div>
        <button
          class="button1 btn w-25 btn-primary invioForm"
          type="submit"
          id="bottoneFinale"
          on:click|preventDefault={sendForm}
          disabled>
          {invio}
        </button>
      </div>
    </form>
    <div class="finale col-sm-12">
      <img src={esito} alt="non trovata" id="esito" class="esito" />
      <p id="esito_txt" class="esito" />
      <button
        class="button1 btn w-25 btn-primary"
        id="fresco"
        on:click|preventDefault={aggiornaPagina}
        style="visibility:hidden">
        {ricarica}
      </button>
    </div>
  </div>
</main>
